import { computed } from 'vue'
import { useMutation, useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import type { IssueLabel } from '@/generated/graphql'
import { issueRefetchQueries } from '@/components/issue/issueRefetchQueries'

export function useOrgIssueLabels() {
  const query = useQuery(gql`
    query IssueDialogOrgLabels {
      issue {
        orgIssueLabels {
          id
          name
          color
        }
      }
    }
  `)

  const orgLabels = computed<IssueLabel[]>(() => query.result.value?.issue.orgIssueLabels || [])

  const setLabelsMutation = useMutation(
    gql`
      mutation IssueDialogSetIssueLabels($issueId: ID!, $labelIds: [ID!]!) {
        issue {
          setIssueLabels(command: { issueId: $issueId, labelIds: $labelIds }) {
            id
          }
        }
      }
    `,
    { refetchQueries: issueRefetchQueries, awaitRefetchQueries: true },
  )

  async function setIssueLabels(issueId: string, labelIds: string[]) {
    await setLabelsMutation.mutate({ issueId, labelIds })
  }

  return {
    orgLabels,
    query,
    loading: query.loading,
    error: query.error,
    refetch: query.refetch,
    result: query.result,
    setIssueLabels,
  }
}
